import { apiClient } from '@/core/infra_api_client'
import type {
  InfraOperation,
  CreateOperationRequest,
  PaginatedResponse,
} from '@/core/infra_types'

const BASE_PATH = 'operations'

export async function listOperations(params?: {
  page?: number
  perPage?: number
  environmentId?: string
  status?: string
  operationType?: string
}): Promise<PaginatedResponse<InfraOperation>> {
  const searchParams: Record<string, string | number | boolean> = {}
  if (params?.page) searchParams['page'] = params.page
  if (params?.perPage) searchParams['per_page'] = params.perPage
  if (params?.environmentId) searchParams['environment_id'] = params.environmentId
  if (params?.status) searchParams['status'] = params.status
  if (params?.operationType) searchParams['operation_type'] = params.operationType

  return apiClient.get<PaginatedResponse<InfraOperation>>(BASE_PATH, searchParams)
}

export async function getOperation(id: string): Promise<InfraOperation> {
  return apiClient.get<InfraOperation>(`${BASE_PATH}/${id}`)
}

export async function createOperation(data: CreateOperationRequest): Promise<InfraOperation> {
  return apiClient.post<InfraOperation, CreateOperationRequest>(BASE_PATH, data)
}

export async function cancelOperation(id: string): Promise<InfraOperation> {
  return apiClient.post<InfraOperation>(`${BASE_PATH}/${id}/cancel`)
}
